import React, { useState } from 'react';
import Button from '../../../NecttosComp/Button/Button';
import Input from '../../../NecttosComp/Input/Input';
import { Module } from '../../types/lms.types';
import { getAxiosTokenInstance } from '../../../utils/axiosInstance';

interface AddModuleModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAddModule: (moduleData: Omit<Module, 'id'>) => void;
  allModules: any[];
  subjectId: string;
}

const AddModuleModal: React.FC<AddModuleModalProps> = ({
  isOpen,
  onClose,
  allModules,
  subjectId,
  onAddModule,
}) => {
  const [moduleName, setModuleName] = useState('');
  const [number, setNumber] = useState<number>(0); // Typing number as number
  const [moduleDescription, setModuleDescription] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {  // Change type to FormEvent
    e.preventDefault();

    // Validate that moduleName is selected
    if (!moduleName.trim()) {
      alert('Please select a module name.');
      return;
    }

    try {
      const fullModuleName = `Module ${number}: ${moduleName.trim()}`;
      const formData = {
        fullModuleName,
        subjectId,
        collegeId: 'COLL-123',  // This could be dynamic if needed
        moduleName,
        description: moduleDescription,
      };

      const response = await (await getAxiosTokenInstance()).post('college/lms/modules/createModule', formData);
      if (response) {
        console.log("add-module", response);
        // Optionally call onAddModule if you want to update the parent component
        // onAddModule({
        //   name: fullModuleName,
        //   description: moduleDescription.trim(),
        //   order: number,
        // });
      }

      // Reset form after submission
      setModuleName('');
      setModuleDescription('');
      setNumber(0);  // Reset the number as well
      onClose();
    } catch (err) {
      console.error("add-module", err);
      alert('An error occurred while creating the module. Please try again later.');
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSubmit(e); // Call handleSubmit when Enter is pressed
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-md">
        <div className="p-6">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl font-bold text-gray-900 dark:text-white">Add New Module</h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Select Module *
              </label>
              <select
                className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
                value={moduleName}
                onChange={(e) => {
                  const selectedModuleName = e.target.value;
                  setModuleName(selectedModuleName);
                  setNumber(allModules.findIndex(module => module.name === selectedModuleName)); // Set the index number based on module name
                }}
              >
                <option value="" disabled>Select a module</option>
                {allModules?.map((module, index) => (
                  <option key={index} value={module.name}>
                    {module.name}
                  </option>
                ))}
              </select>

              <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                Will be prefixed with "Module Number:"
              </p>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Description (Optional)
              </label>
              <textarea
                className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg resize-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
                placeholder="Brief description of the module..."
                rows={3}
                value={moduleDescription}
                onChange={(e) => setModuleDescription(e.target.value)}
                onKeyPress={handleKeyPress}
              />
            </div>
          </div>

          <div className="flex justify-end gap-3 mt-6">
            <Button type="close" onClick={onClose}>
              Cancel
            </Button>
            <Button type="save" onClick={handleSubmit}>
              Add Module
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddModuleModal;
